import { render, staticRenderFns } from "./Playground.vue?vue&type=template&id=1f3b2274&scoped=true"
import script from "./Playground.vue?vue&type=script&lang=js"
export * from "./Playground.vue?vue&type=script&lang=js"
import style0 from "./Playground.vue?vue&type=style&index=0&id=1f3b2274&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3b2274",
  null
  
)

export default component.exports